export default __webpack_public_path__ + "static/media/icon-sensitive.9d7f07a3.svg";